import { getFileExtension } from './get-file-extension.util';

export const getIsVideoFormat = (fileName?: string | null) => {
  const videoFormats = ['mp4'];
  const fileFormat = getFileExtension(fileName);

  return fileFormat && videoFormats.includes(fileFormat);
};
